module.exports = __webpack_public_path__ + "static/img/zgj-logo.960dffe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Login/zgj-logo.svg
// module id = r7fX
// module chunks = 1